import firebase from "config/firebase";
export const fetchCollegeStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_COLLEGE_STATES",
        payload: tempStates,
      });
    });
};
export const fetchSchoolStates = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("school_states")
    .orderBy("name", "asc")
    .onSnapshot((query) => {
      var tempStates = [];
      query.forEach((doc) => {
        tempStates.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_SCHOOL_STATES",
        payload: tempStates,
      });
    });
};
export const getCollegeCity = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("state", "==", state)
    .orderBy("city", "asc")
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_CITY_BY_STATE", payload: temp });
    });
};
export const getSchoolCounty = (state) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    .orderBy("county", "asc")
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "GET_COUNTY_BY_STATE", payload: temp });
    });
};
export const SchoolsAndCollegesData = (state, college) => async (dispatch) => {
  const handleSnapshot = (querySnapshot) => {
    let temp = [];
    querySnapshot.forEach((doc) => {
      temp.push({
        ...doc.data(),
        id: doc.id,
      });
    });
    dispatch({ type: "NEW_SCHOOLSANDCOLLEGES", payload: temp });
  };

  await firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    // .where("county", "==", college)
    .onSnapshot(handleSnapshot, (error) => {
    });
  // } else {
  await firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("state", "==", state)
    // .where("city", "==", college)
    .onSnapshot(handleSnapshot, (error) => {
    });
  // }
};
export const getAllSchoolsAndColleges = () => async (dispatch) => {
  const handleSnapshot = (querySnapshot) => {
    let temp = [];
    querySnapshot.forEach((doc) => {
      temp.push(...doc.data().institutes);
    });
    const filteredData = temp.filter((item) => item !== "OTHER");
    dispatch({ type: "GET_ALL_SCHOOLS_AND_COLLAGES", payload: filteredData });
  };

  await firebase
    .firestore()
    .collection("test_schools")
    .onSnapshot(handleSnapshot, (error) => {
    });

  await firebase
    .firestore()
    .collection("test-colleges-universities")
    .onSnapshot(handleSnapshot, (error) => {
    });
};
export const newSchoolsData = (state, college) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test_schools")
    .where("state", "==", state)
    .where("county", "==", college)
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({
          ...doc.data(),
        });
      });
      dispatch({ type: "NEW_SCHOOLS", payload: temp });
    });
};
export const newCollegeUniversitiesData =
  (state, college) => async (dispatch) => {
    firebase
      .firestore()
      .collection("test-colleges-universities")
      .where("state", "==", state)
      .where("city", "==", college)
      .onSnapshot((query) => {
        let temp = [];
        query.forEach((doc) => {
          temp.push({
            ...doc.data(),
          });
        });
        dispatch({ type: "NEW_COLLEGE_UNIVERSITIES", payload: temp });
      });
  };
export const newCollegeUniversitiesDataByID = (school) => async (dispatch) => {
  firebase
    .firestore()
    .collection("test-colleges-universities")
    .where("institutes", "array-contains", school)
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: "GET_NEW_COLLEGE_BY_ID", payload: temp });
    });
};
export const newSchoolsDataByID = (school) => async (dispatch) => {
  await firebase
    .firestore()
    .collection("test_schools")
    .where("institutes", "array-contains", school)
    .onSnapshot((query) => {
      let temp = [];
      query.forEach((doc) => {
        temp.push({ id: doc.id, ...doc.data() });
      });
      dispatch({ type: "GET_NEW_SCHOOLS_BY_ID", payload: temp });
    });
};
export const getAtheletes = () => {
  return async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("role", "==", "athlete")
      .onSnapshot((query) => {
        var athletes = [];
        query.forEach((doc) => {
          athletes.push({ id: doc.id, ...doc.data() });
        });
        dispatch({
          type: "GET_ATHLETES",
          payload: athletes,
        });
      });
  };
};
export const singleAthlete = (id) => {
  return async (dispatch) => {
    dispatch(addSchoolLoader(true));
    firebase
      .firestore()
      .collection("users")
      .doc(id)
      .onSnapshot((query) => {
        dispatch(addSchoolLoader(false));
        dispatch({
          type: "GET_SINGLE_ATHLETE",
          payload: { ...query.data(), id: query.id },
        });
      });
  };
};
export const getSingleFan = (id) => {
  return async (dispatch) => {
    dispatch(addSchoolLoader(true));
    firebase
      .firestore()
      .collection("users")
      .doc(id)
      .onSnapshot((query) => {
        dispatch(addSchoolLoader(false));
        dispatch({
          type: "GET_SINGLE_FAN",
          payload: query.data(),
        });
      });
  };
};
// Get Schools Action
export const addSchoolLoader = (val) => async (dispatch) => {
  dispatch({ type: "ADD_SCHOOLS_LOADER", payload: val });
};
export const getSchools = () => async (dispatch) => {
  firebase
    .firestore()
    .collection("schools")
    .orderBy("school", "asc")
    .onSnapshot((query) => {
      var tempSchool = [];
      query.forEach((doc) => {
        tempSchool.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_SCHOOLS",
        payload: tempSchool,
      });
    });
};
// Get Schools BY ID
export const getSchoolsById = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("schools")
    .where("user_Id", "==", id)
    .orderBy("school", "asc")
    .onSnapshot((query) => {
      var tempSchool = [];
      query.forEach((doc) => {
        tempSchool.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "GET_SCHOOLS_BY_ID",
        payload: tempSchool,
      });
    });
};
export const addSchools =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch(addSchoolLoader(true));
    firebase
      .firestore()
      .collection("schools")
      .add(data)
      .then(() => {
        dispatch(addSchoolLoader(false));
        onSuccess();
      })
      .catch((err) => {
        dispatch(addSchoolLoader(false));
      });
  };
